import React from 'react';
import styles from './Footer.module.scss';

const Footer = () => (
  <div className={styles['footer']}>
    <div className={styles['footer__inner']}>
      Site by <a href="https://toddohanian.com">Todd Ohanian</a>
    </div>
  </div>
);

export default Footer;
